
import * as React from "react"
import { Typography, type TypographyProps } from "./base"

// Toast title variant
export const ToastTitle = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as" | "size" | "variant">>(
  ({ className, weight = "medium", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h3"
      variant="default"
      size="body"
      weight={weight}
      className={cn("select-text", className)}
      {...props}
    />
  )
)
ToastTitle.displayName = "ToastTitle"

// Toast description variant
export const ToastDescription = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "as" | "size" | "variant">>(
  ({ className, ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant="subtle"
      size="body"
      className={cn("select-text", className)}
      {...props}
    />
  )
)
ToastDescription.displayName = "ToastDescription"

// Import cn utility which was missing
function cn(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}
